import * as React from "react";

import classNames from "classnames";
import { getAriaLabel } from "./iconButtonHelpers";

interface DocBookmarkProps {
  uid: string;
  bookmarked?: boolean;
  content?: any; // InlineNode - can be string or styled text object
  type?: string;
  title?: any;

  currentVersion: CurrentVersion;
  userContext: UserContext;
  displayContext: DisplayContext;
  documentContext: DocumentContext;
}

export default function DocBookmark(props: DocBookmarkProps) {
  const {
    currentVersion,
    userContext,
    uid,
    bookmarked,
    displayContext,
    documentContext,
    content,
    type,
    title,
  } = props;

  if (currentVersion.disableBookmarks || displayContext.canBeEditing || displayContext.isEmbeded) { return null; }

  const onClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    const newBookmarkState = !bookmarked;

    userContext.addState({
      [uid]: { bookmarked: newBookmarkState },
    });

    displayContext.setFocusedBookmarkUid(newBookmarkState ? uid : null);

    e.stopPropagation();
  };

  const bookmarkButtonRef = React.useRef<HTMLButtonElement>(null);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLButtonElement>) => {
    if (e.key === "Escape") {
      if (bookmarked) {
        userContext.addState({ [uid]: { bookmarked: false } });
        displayContext.setFocusedBookmarkUid(null);
      }
      bookmarkButtonRef.current?.blur();
      e.stopPropagation();
    }
  };

  return (
    <button
      type="button"
      id={`bookmark${uid}`}
      className={classNames("doc-bookmark-button", {bookmarked: bookmarked})}
      onClick={onClick}
      aria-pressed={!!bookmarked}
      aria-label={getAriaLabel(content, !!bookmarked, "Remove bookmark from", "Bookmark", {
        title,
        type,
        uid,
      })}
      ref={bookmarkButtonRef}
      onKeyDown={handleKeyDown}
    >
      <span className="icon-bookmark" aria-hidden="true" />
    </button>
  );
}
